import { RadioCard, RadioGroup } from 'components/ui/radio-group';
import { TierCode } from 'types/clientIdentification';
import { t } from 'utils/getTranslations';
import { useTierOptions } from './tierOptions';

interface Props {
    value: TierCode | null;
    onChange: (code: TierCode) => void;
    /** The id of the label drawn over the cards; without one, the cards are named "Tier". */
    labelledBy?: string;
}

/** The tiers as radio cards: the name over the caption, nothing chosen until the user picks one. */
export function TierRadioCards({ value, onChange, labelledBy }: Props) {
    const { options } = useTierOptions();
    return (
        <RadioGroup
            value={value}
            onValueChange={(code) => onChange(code as TierCode)}
            aria-label={labelledBy ? undefined : t('client-identification.tier')}
            aria-labelledby={labelledBy}
            aria-required
            className="gap-2"
        >
            {options.map((option) => (
                <RadioCard key={option.code} value={option.code} title={option.name} description={option.caption} />
            ))}
        </RadioGroup>
    );
}
